<template>
  <login :params="params" :query="query"/>
</template>

<script>
import login from '~/components/pages/login'
export default {
  async asyncData ({params, query, redirect, app, store, route, error,req}) {
    return {
      params,
      query
    }
  },
  head () {
    return {
      title: this.$t('TDK.index.title'),
      meta: [
        { hid: 'keywords', name: 'keywords', content: this.$t('TDK.index.keywords') },
        { hid: 'description', name: 'description', content: this.$t('TDK.index.description') }
      ],
    };
  },
  data() {
    return{
      
    }
  },
  created(){
  },
  mounted(){
  },
  destroyed(){
  },
  components: {
    login
  },
  methods:{
    
  }
}
</script>

<style lang="scss" scoped>

</style>
